module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style9/message-alert-style9.component.scss
// module id = ./src/app/features/message-alert/message-alert-style9/message-alert-style9.component.scss
// module chunks = main